import React from "react";
import "./designSturcture.css";
import { Link } from "react-router-dom";

export default function DesignSturcture() {
  return (
    <section className="designSturcture">
      <div className="designHead">
        <h1>Design an E-Structure for your Client in 5 Minutes</h1>
        <p>
          With our design tool, you or your client have the possibility to design a desired substructure for a building. The design tool can
          be used to define roofs with various properties, such as roof pitch, roof
          covering or even interfering surfaces.
        </p>
        <Link to="/signIn">
        <button className="designButton">Let design through Smith PVX Solar Design Tool</button>
        </Link>
      </div>
      <div className="designImage">
        <div className="backScreen">
          <img src="./images/Solutions/Screen.png" alt="screen"></img>
        </div>
        <div className="keyboardZone"></div>
        <div className="underKeyboardZone"></div>
      </div>
    </section>
  );
}
